import { envelopeField, type MaeizEnvelope } from "@maeiz/core";
import { httpClient } from "@api/http";

export interface NotificationDto {
    id: string;
    title: string;
    message: string;
    type: string;
    data: Record<string, unknown>;
    url: string | null;
    readAt: string | null;
    createdAt: string | null;
}

export interface NotificationsPagination {
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
    from: number | null;
    to: number | null;
}

export interface NotificationsListResult {
    notifications: NotificationDto[];
    unreadCount: number;
    pagination: NotificationsPagination;
}

const DEFAULT_PAGINATION: NotificationsPagination = {
    currentPage: 1,
    lastPage: 1,
    perPage: 15,
    total: 0,
    from: null,
    to: null,
};

export const notificationsApi = {
    list: async (params?: {
        page?: number;
        perPage?: number;
        unreadOnly?: boolean;
    }): Promise<NotificationsListResult> => {
        const qs = new URLSearchParams();
        if (params?.page) qs.set("page", String(params.page));
        if (params?.perPage) qs.set("perPage", String(params.perPage));
        if (params?.unreadOnly) qs.set("unreadOnly", "true");
        const query = qs.toString();
        const res = (await httpClient.get<unknown>(
            `/customer/notification/list${query ? `?${query}` : ""}`
        )) as unknown as MaeizEnvelope;
        return {
            notifications: envelopeField<NotificationDto[]>(res, "notifications", []) ?? [],
            unreadCount: envelopeField<number>(res, "unreadCount", 0),
            pagination: envelopeField<NotificationsPagination>(
                res,
                "pagination",
                DEFAULT_PAGINATION
            ),
        };
    },

    unreadCount: async (): Promise<number> => {
        const res = (await httpClient.get<unknown>(
            "/customer/notification/unread-count"
        )) as unknown as MaeizEnvelope;
        return envelopeField<number>(res, "unreadCount", 0);
    },

    markRead: async (id: string): Promise<void> => {
        await httpClient.patch(`/customer/notification/${id}/read`);
    },

    markAllRead: async (): Promise<void> => {
        await httpClient.post("/customer/notification/mark-all-read");
    },

    delete: async (id: string): Promise<void> => {
        await httpClient.delete(`/customer/notification/${id}`);
    },
};
